import { render, staticRenderFns } from "./ProgramPOACalendar.vue?vue&type=template&id=5010b4ca"
import script from "./ProgramPOACalendar.vue?vue&type=script&lang=js"
export * from "./ProgramPOACalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports